import { render } from "./introsection.vue?vue&type=template&id=b49b1560"
import script from "./introsection.vue?vue&type=script&lang=js"
export * from "./introsection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__